import { useQuery } from 'src/core/api/hooks/useQuery';
import { type QueryState } from 'src/core/api/queryState';

export type CardActivity = {
  id: string;
  created_at: string;
  activity_type: string;
  user: {
    fullname: string;
  };
};

type CardActivityQueryOptions = {
  isEnabled?: boolean;
};

export const useCardActivityQuery = (
  cardId: string,
  queryOptions: CardActivityQueryOptions = { isEnabled: true },
): QueryState<CardActivity[]> => {
  const { isEnabled } = queryOptions;

  return useQuery<CardActivity[], CardActivity[]>({
    key: ['cards', cardId, 'activity'],
    request: {
      type: 'rest',
      target: 'companyAPI',
      endpoint: `/cards/${cardId}/activity`,
    },
    isEnabled,
    reshapeData: (data) => data,
  });
};
